import { CHANGE_A1 } from "./refsActions";



const INITIAL_STATE = {
  ref1: false,
};

const refsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CHANGE_A1:
      return {
        ...state,
        openMessage: action.payload
      };




    default:
      return state;
  }
};

export default refsReducer;
